import { render, staticRenderFns } from "./UnifiedControlDescriptorBase.vue?vue&type=template&id=3410277c&lang=pug&"
import script from "./UnifiedControlDescriptorBase.vue?vue&type=script&lang=js&"
export * from "./UnifiedControlDescriptorBase.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports